<div>
  <ngx-slick-carousel class="carousel" 
  #slickModal="slick-carousel" 
  [config]="slideConfig" 
  (init)="slickInit($event)">
    <div ngxSlickItem *ngFor="let slide of slides" class="slide">
      <img src="{{ slide.img }}" alt="" width="100%">
    </div>
  </ngx-slick-carousel>
</div>